import { makeScalarToken } from '@utils/css';

const rotation = makeScalarToken("--rotation", "0deg");
const overlayCls = "_086ofbsgg5";
const dragHandleCls = "_086d14d5a7l";
const deleteHandleCls = "_086dhp33gh";
const buttonCls = "_086bhurbc5";

export { buttonCls, deleteHandleCls, dragHandleCls, overlayCls, rotation };
import "./After.style.linaria.module.css";
//# sourceMappingURL=After.style.js.map
